<template lang="pug">
  .component-client-reservations
    ActionBar
      h2(slot="title") Deposits
    base-list(ref="loader", :component="component", :dataLoader="dataLoader", :resultsPerPage="5")

</template>
<script type="text/babel">
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import ReservationListForm from 'components/structure/ui/filters/ReservationListForm'
    import BookPanel from 'components/structure/ui/BookPanel'
    import BaseList from '../../../pages/backoffice/BaseList'
    import ActionBar from '../../structure/ui/ActionBar'

    export default {
        name: 'TabbedClientDeposits',
        components: {
            ActionBar,
            BaseList,
            BookPanel,
            ReservationListForm,
        },
        data() {
            return {
                component: require('components/backoffice/Deposit'),
                reservations: [],
                search: {
                    client_id: this.$route.params.id
                },
                drivers: [],
                deposits: [],
            }
        },
        created() {

        },
        methods: {
            dataLoader(callback, page, resultsPerPage) {
                KeplerBackofficeSdk.clients.select(this.$route.params.id).deposits(page, resultsPerPage, (data) => {
                    callback(data)
                    this.deposits = data
                })
            },

        }
    }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-client-reservations
    .action-bar
      display: flex
      flex-flow: row nowrap
      justify-content: space-between
      align-items: center

      .action
        display: flex
        flex-flow: row
        align-items: center
        width: unset

        .entity-filters
          margin-right: 1em

          select
            height: 1.8em
</style>



// WEBPACK FOOTER //
// ClientDeposits.vue?1d6ad678